import { useTranslation } from 'react-i18next'

import { Alert, ComboBox, Text } from '@reveni-io/reveni-ui'

import CarrierSelector from '@/common/components/CarrierSelector/CarrierSelector'

import { shouldRenderLocationWarning } from './helpers'
import * as Styles from './styles'

const NewShipmentSettings = ({
  carrierServices,
  carrierServiceForNewShipment,
  setCarrierServiceForNewShipment,
  locationForNewShipment,
  setLocationForNewShipment,
  senderLocation,
  locations,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.NewShipmentContainer>
      <Styles.TitleContainer>
        <Text type="titleS">{t('Ajustes nuevo envío')}</Text>
      </Styles.TitleContainer>

      <CarrierSelector
        carriers={carrierServices}
        value={carrierServiceForNewShipment}
        onChange={carrier => setCarrierServiceForNewShipment(carrier.id)}
      />
      <Styles.LocationsSelectorContainer>
        <ComboBox
          value={locationForNewShipment}
          handleChange={e => setLocationForNewShipment(e.target.value)}
          label={t('Ubicación')}
          fullWidth
          menuItems={locations?.map(l => ({ label: `${l.internal_id} | ${l.internal_name}`, value: l.id })) || []}
        />
        {shouldRenderLocationWarning(senderLocation, locationForNewShipment, locations) && (
          <Alert type="warning">
            {t(
              'La nueva ubicación se encuentra en una región diferente y esto puede afectar a los costes de aduana del envío.'
            )}
          </Alert>
        )}
      </Styles.LocationsSelectorContainer>
    </Styles.NewShipmentContainer>
  )
}

export default NewShipmentSettings
